
define('modules/application/login',[
    'app',

    // Libs
    'backbone',

    //Classes
    './popup',

    //Plugins
    'plugins/jquery-colorbox',
    'plugins/jquery-cookie',
    // 'sso/iam'
    // 'http://iam.bticino.it/iamquality/iam-1.1.0.js'
    'sso/iam1'
  ],

  function(app, Backbone, Popup) {

    // Create a new module
    var Login = app.module();

    Login.Model = Backbone.Model.extend({
      defaults: {
        username: '',
        password: '',
        remember: false,
        token: '',
        branchLocalizationId: '',
        authenticated: false,
        isSSO: false,
        category: ''
      },

      initialize: function() {
        window.BticinoS4B.eventAggregator.bind('logout:requested', this.requestDeauthentication, this);
      },

      setUserName: function(newUserName) {
        this.set('username', newUserName);
      },

      setPassword: function(newPassword) {
        this.set('password', newPassword);
      },

      setRemember: function(newRemember) {
        this.set('remember', true);
      },

      setCategory: function(value) {
        this.set('category', value);
      },

      baseAuthentication: function(isSSO_in, callback_in) {
        var that = this,
          scadenza = new Date();

        functionDone = function() {
          if (that.get('authenticated') === true)
            window.BticinoS4B.eventAggregator.trigger('autoLogin:completed', that);
          else
            window.BticinoS4B.eventAggregator.trigger('authentication:fail', that);
        },
        successGetUserCB = function(data) {
          _.extend(that.attributes, data);
          if (isSSO_in) {
            var branchLocalizationId = 'ITA';
          } else {
            var branchLocalizationId = that.get('branchLocalizationId');
          }
          switch (branchLocalizationId) {
            case 'ITA':
              BticinoS4B.Instances.Models.ApplicationModel.set('catalogId', that.get('catalogs')[0].code);
              break;
            case 'FRA':
              BticinoS4B.Instances.Models.ApplicationModel.set('catalogId', that.get('catalogs')[1].code);
              break;
          }
          that.set('authenticated', true);
          that.set('isSSO', isSSO_in);
          BticinoS4B.Instances.Models.loginModel.set('branchLocalizationId', branchLocalizationId);
          scadenza.setMinutes(scadenza.getMinutes() + 30);

          $.cookie('token', window.BticinoS4B.token, {
            expires: scadenza,
            path: '/'
          });

          window.BticinoS4B.Instances.Services.wizardServices.setCurrentLanguage(branchLocalizationId);

          window.BticinoS4B.Instances.Services.wizardServices.setCurrentLocalization(branchLocalizationId);
          //functionDone();

          if (callback_in) {
            callback_in.apply(that);
          }

        },
        failedGetUserCB = function() {
          $.removeCookie('token');
          //$.removeCookie('apex__currentuser');
          //functionDone();
          if (callback_in) {
            callback_in.apply(that);
          }
        };

        window.BticinoS4B.Instances.Services.wizardServices.getUser(successGetUserCB, failedGetUserCB, that);

      },

      autoAuthentication: function() {
        var that = this,
          autoAuthenticationCB = function() {
            if (that.get('authenticated') === true)
              window.BticinoS4B.eventAggregator.trigger('autoLogin:completed', that);
            else
              window.BticinoS4B.eventAggregator.trigger('authentication:fail', that);
          };

        //console.log($.cookie('token'));
        //console.log($.cookie('apex__currentuser'));

        if ($.cookie('token')) {
          window.BticinoS4B.token = $.cookie('token');

          if (that.get('isSSO')) {
            that.baseAuthentication(true, autoAuthenticationCB);
          } else {
            that.baseAuthentication(false, autoAuthenticationCB);
          }


        }

      },

      authenticationChangedEventHandler: function() {
        if (this.get('authenticated') === true)
          window.BticinoS4B.eventAggregator.trigger('authentication:success', this);
        else
          window.BticinoS4B.eventAggregator.trigger('authentication:fail', this);
      },

      requestAuthenticationSSO: function(username, category, callback) {
        var that = this,
          scadenza = new Date(),
          returnData = null;

        $.ajax({
          url: '/WizardService.svc/LoginSSO',
          type: 'post',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({
            user: username,
            category: category
          }),

          success: function(data) {

            scadenza.setMinutes(scadenza.getMinutes() + 30);
            /*
            $.cookie('apex__currentuser', username, {
              expires: scadenza,
              path: '/'
            });
            */
            returnData = data;
            if (returnData.result) {
              //Setting up attributes
              //that.set('token', returnData.token);
              window.BticinoS4B.token = returnData.token;
              //Retrieving user details
              that.baseAuthentication(true);
            } else
              that.attributes = {};
          }
        }).done(function(msg) {
          if (that.get('authenticated') === true)
            window.BticinoS4B.eventAggregator.trigger('authentication:success', that);
          else
            window.BticinoS4B.eventAggregator.trigger('authentication:fail', that);

          return returnData;
        });
      },

      requestAuthentication: function() {
        var returnData = null;
        var that = this;

        $.ajax({
          url: '/WizardService.svc/Login',
          type: 'post',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({
            user: this.get('username'),
            password: this.get('password'),
            remember: this.get('remember')
          }),
          success: function(data) {
            returnData = data;
            if (returnData.result) {
              //Setting up attributes
              //that.set('token', returnData.token);
              window.BticinoS4B.token = returnData.token;
              //Retrieving user details
              that.baseAuthentication(false);
            } else
              that.attributes = {};
          }
        }).done(function(msg) {
          if (that.get('authenticated') === true)
            window.BticinoS4B.eventAggregator.trigger('authentication:success', that);
          else
            window.BticinoS4B.eventAggregator.trigger('authentication:fail', that);

          return returnData;
        });
      },

      requestDeauthentication: function() {
        var self = this,
          successLogoutCB = function(data) {
            $.removeCookie('token');
            //$.removeCookie('apex__currentuser');
            window.location.href = '/';
          },
          failedLogoutCB = function() {
            //
          };
        if (self.get('isSSO')) {
          self.get('iam').showLogin();
        } else {
          window.BticinoS4B.Instances.Services.wizardServices.logout(successLogoutCB, failedLogoutCB, self);
        }

      },

      isAuthenticated: function() {
        if (this.get('authenticated') === true)
          return true;
        else
          return false;
      }

    });

    // Login Main View
    // ----------
    Login.View = Backbone.View.extend({
      keep: true,
      tagName: 'section',
      className: 'login',
      template: 'application/login',
      events: {
        'click .login-button': 'requestAuthentication',
        'click .linkSSO-button': 'showLoginIAM',
        'keypress :input': 'keyPressedOnLoginForm',
        'change #loginCountry': 'getLoginByCountry'
      },
      serialize: function() {
        return {
          model: this.model
        };
      },

      initialize: function() {
        var iam;
        this.setupportale();
        if(this.model.isAuthenticated()){
          this.model.get('iam').run();
          this.model.get('iam').refreshSession();
        }
        this.failMessage = new Login.MessageView({
          model: {
            title: 'IDS_W1_9066',
            description: 'IDS_W1_9066',
            closeButton: false
          }
        });
        this.loader = new window.BticinoS4B.Instances.Views.LoaderView({
          model: {
            quote: 'IDS_W1_9058',
            closeButton: false
          }
        });
        if (this.model !== undefined)
          _.extend(this.model, {
            eventAggregator: this.options.eventAggregator
          });
        else
          this.model = new Login.Model({
            eventAggregator: this.options.eventAggregator
          });

        window.BticinoS4B.eventAggregator.bind('authentication:success', this.authenticationSuccessEventHandler, this);
        window.BticinoS4B.eventAggregator.bind('authentication:fail', this.authenticationFailedEventHandler, this);

        // window.BticinoS4B.eventAggregator.unbind('language:changed', this.render);
        window.BticinoS4B.eventAggregator.bind('language:changed', this.render, this);
        //console.log(window.BticinoS4B.eventAggregator);

        //Injecting popup views
        this.insertView('.popups', this.loader);
        this.insertView('.popups', this.failMessage);
        //this.model.set('country', window.BticinoS4B.Instances.Models.ApplicationModel.get('currentLanguage'));
        this.model.set('country', 'ITA');
      },
      getLoginByCountry: function(event) {
        var valueCountry = $(event.target).val();
        this.model.set('country', valueCountry);
        this.render();
      },

      showLoginIAM: function() {
        var callbackShowLogin = function() {
          //console.log('iam.showLogin OK');
          this.$('iframe').attr('width', '600px');
          this.$('iframe').attr('height', '600px');
        };
        this.model.get('iam').showLogin(600, callbackShowLogin);
      },

      setupportale: function() {
        var self = this,
          urlPortale,
          idportal,
          enabledCategorySSO = ['FTC', 'CAT', 'IQ', 'MKO', 'DIP', 'DIPENDENTE', 'GG', 'CIT', 'ST'],
          enabledClassOfIQ = ['A', 'B', 'C'],

          initcallback = function() {
            this.$('iframe').on("message", function(e) {
              console.log("Received messsage from " + e.originalEvent.origin + ", data = " + e.originalEvent.data);
            });

            //this.$('iframe').removeAttr('style');
            //self.$el.find('#loginSSO').html(this.$('iframe'));
            //iam.refreshCookie();
          },
          cblogin = function(iamresponse) {
            console.log('cblogin' + iamresponse);
            var callbackClose = function() {
              //
            },
              callbackRequestAuthenticationSSO = function() {
                //window.BticinoS4B.eventAggregator.trigger('login:completed', self);
              };
            if(iamresponse.action!="confirm"){

              var categoryIndex = enabledCategorySSO.indexOf(iamresponse.CATEGORIA_ID);
              if (categoryIndex >= 0) {
                console.log(iamresponse);
                self.model.setUserName(iamresponse.user);
                self.model.setCategory(iamresponse.CATEGORIA_ID);
                self.model.get('iam').closeLogin(callbackClose);

                if (!self.model.get('authenticated')) {
                  self.model.requestAuthenticationSSO(iamresponse.user, iamresponse.CATEGORIA_ID, callbackRequestAuthenticationSSO);
                }
                self.model.set('authenticated', true);
              } else {
                alert('L utente appartiene ad una categoria non abilitata al servizio');
              }
            }

            //console.log('login action callback, json output:' + JSON.stringify(iamresponse));
          },
          cblogout = function(iamresponse) {
            $.removeCookie('token');
            //$.removeCookie('apex__currentuser');
            window.location.href = '/';
          },
          cbreg = function(iamresponse) {
            // alert('Registrazione action callback');
          },
          cbrule = function(iamresponse) {
            // alert('cbrule' + iamresponse);
          },
          changeLangCallback = function() {
            // alert('changeLangCallback');
          },
          changeLang = function() {
            this.model.get('iam').setLang('US', changeLangCallback);
          },
          refreshCookieCallback = function() {
            // alert('refreshCookieCallback');
          },
          refreshCookie = function() {
            // this.model.get('iam').refreshCookie(0.5, refreshCookieCallback);
          },
          errfunc = function() {
            alert('errfunc');
          };

        // 'a2QM00000014VKa' idPortal fornito da salesforce
        // this.model.set('iam', new IamLogin('https://bticino.dev6.cs7.force.com/', 'a2QM00000014VKa', 'IT', 'loginSSO', cblogin, cblogout, cbreg, cbrule));
        // 'a2QM00000004cKQ' idPortal copiato da http://mdcdev.bticino.it/#
        // this.model.set('iam', new IamLogin('https://bticino.dev6.cs7.force.com/', 'a2QM00000004cKQ', 'IT', 'loginSSO', cblogin, cblogout, cbreg, cbrule));


        // nuovi parametri segnalati nella mail From: <ramona.tocchella@bticino.it> Date: Fri, Feb 21, 2014 at 2:51 PM
        // webapp in stage
        // this.model.set('iam', new IamLogin('https://quality-bticino.cs7.force.com/', 'a2bM00000004vhq', 'IT', 'loginSSO', cblogin, cblogout, cbreg, cbrule));
        // webapp in dev
        // this.model.set('iam', new IamLogin('https://quality-bticino.cs7.force.com/', 'a2bM00000004x0I', 'IT', 'loginSSO', cblogin, cblogout, cbreg, cbrule));

        switch (BticinoS4B.baseUrl) {
          case 'http://localhost:81/':
            urlPortale = 'https://bticino.dev6.cs7.force.com/';
            idPortal = 'a2bM000000051qR';
            break;
          case 'http://webapp.creeostudio.it/':
            urlPortale = 'https://quality-bticino.cs7.force.com/';
            idPortal = 'a1uM00000009jrL​​'; // mail di Andrea del 20140513 - Fwd: ATTENZIONE: IAM - Aggiornamento quality - Cambio ID Portale - WebApp
            break;
          case 'http://webapp-dev.creeostudio.it/':
            urlPortale = 'https://quality-bticino.cs7.force.com/';
            //idPortal = 'a2bM00000004x0I';
            //idPortal = 'a2bM00000004vhq';
            idPortal = 'a1uM00000009jrL​​'; // mail di Andrea del 20140513 - Fwd: ATTENZIONE: IAM - Aggiornamento quality - Cambio ID Portale - WebApp
            break;
          case 'http://www.softwareforbusiness.homesystems-legrandgroup.com/':
            urlPortale = 'https://bticino.secure.force.com/';
            idPortal = 'a1uD0000000jDQK';
            break;
          default:
            urlPortale = 'https://quality-bticino.cs7.force.com/';
            idPortal = 'a2bM00000004x0I';
        }

        this.model.set('iam', new IamLogin(urlPortale, idPortal, 'IT', 'loginSSO', cblogin, cblogout, cbreg, cbrule));
        this.model.get('iam').init(initcallback, errfunc);

      },

      keyPressedOnLoginForm: function(e) {
        if (e.keyCode == 13)
          this.requestAuthentication();
      },

      requestAuthentication: function() {
        this.showLoader();
        this.model.setUserName(this.$el.find('input[name="username"]').val());
        this.model.setPassword(this.$el.find('input[name="password"]').val());
        this.model.setRemember(this.$el.find('input[name="remember"]:checked').length > 0);
        this.model.requestAuthentication();
      },

      authenticationSuccessEventHandler: function() {
        var that = this;
        if (this.model.get('isSSO'))
          window.BticinoS4B.eventAggregator.trigger('login:completed', this);
        else
          that.hideLoader(that.SuccessMessage);
      },

      authenticationFailedEventHandler: function() {
        this.hideLoader(this.showFailMessage);
      },

      showLoader: function() {
        this.loader.show();
      },

      hideLoader: function(callback) {
        var that = this;
        this.loader.model.set('callback', callback);
        this.loader.model.set('callbackScope', this);
        setTimeout(function() {
          that.loader.hide(callback);
        }, 500);
      },

      SuccessMessage: function() {
        window.BticinoS4B.eventAggregator.trigger('login:completed', this);
      },

      showFailMessage: function() {
        this.failMessage.show();
      },

      afterRender: function() {
        setTimeout(function() {
          window.customizeFormElements.call();
        }, 0);
      }

    });

    // Login Messages Popup
    Login.MessageView = Popup.View.extend({
      className: 'popup message',
      template: 'application/popups/message',
      closeButton: false,
      events: {
        'click .closeButton': 'closeButtonClickedEventHandler'
      },

      serialize: function() {
        return {
          model: this.model,
          app: BticinoS4B.Instances.Models.ApplicationModel
        };
      },

      cleanup: function() {
        this.model.off(null, null, this);
      },

      afterRender: function() {
        var that = this;
        this.$el.find('.closeButton').on('click', that.closeButtonClickedEventHandler, that);
      }

    });

    // Required, return the module for AMD compliance
    return Login;

  });